export default() => {

  const moveTo = new MoveTo();
  window.sr = ScrollReveal({
    viewFactor: 1,
    duration: 500
  });

  // after loading
  window.addEventListener('load', () => {
    const triggers = document.getElementsByClassName('js-trigger');
    for (let i = 0; i < triggers.length; i++) {
      moveTo.registerTrigger(triggers[i]);
    }

    sr.reveal('.reveal');
    sr.reveal('.reveal-q1', 1000);
    sr.reveal('.reveal-q5', 1000);
  });
}